// pages/index.js

import React, { useState, useEffect } from 'react';
import NameAvailability from './NameAvailability';

export default function DomainAvailability({ domainName }) {
  const [availability, setAvailability] = useState(null);

  const checkDomainAvailability = async () => {
    try {
      const response = await fetch(
        `/api/domain-availability?domain=${domainName}`,
      );
      const data = await response.json();
      setAvailability(data.isAvailable);
    } catch (error) {
      console.error('Error checking domain availability:', error);
    }
  };

  useEffect(() => {
    if (domainName) {
      checkDomainAvailability();
    }
  }, [domainName]);

  return (
    <div>
      <NameAvailability isAvailable={availability} name={domainName} />
    </div>
  );
}
